import React from 'react';
import { Row, Col, Button } from '@thd-olt-component-react/core-ui';
import { HashLink } from 'react-router-hash-link';
import { addAnalyticEvent } from '../../analytics/common';
import { linkToLearnMore } from '../../analytics/outboundLinks';

export function VisitPrivacyCenter() {

  const handleClick = () => {
    addAnalyticEvent(linkToLearnMore);
  };

  return (
    <div className="component">
      <Row>
        <Col>
          <h2>
            <u style={{ textDecorationColor: '#F96302' }}>Visit the Privacy & Security Center</u>
          </h2>
        </Col>
      </Row>

      <Row>
        <Col>
          <p>
            At The Home Depot, we appreciate that you trust us with your personal information,
            and we’re committed to using your information in ways that create value for you.
            Visit the Privacy & Security Center to learn about what we do with your data and
            access tools to take actions.
          </p>
        </Col>
      </Row>
      <Row>
        <Col nopadding xs={6} sm={8} md={8} lg={8} />
        <Col xs={6} sm={4} md={4} lg={4}>
          <HashLink to="/privacy/overview">
            <Button outline onClick={handleClick}>
              Learn more
            </Button>
          </HashLink>
        </Col>
      </Row>
    </div>
  );
}
